/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

import React from "react";
import { Button } from "@mui/material";

const LinkButton = ({ children, onClick, to, ...props }) => {
  return (
    <Button
      variant="text"
      onClick={onClick}
      href={to}
      sx={{
        padding: 0,
        minWidth: 0,
        textTransform: "none",
        color: "#1976d2",
        fontSize: "1rem",            // Match body1 size
        fontWeight: 400,             // Match body1 weight
        lineHeight: "1.5",           // Match body1 line height
        fontFamily: '"Roboto","Helvetica","Arial",sans-serif', // Match MUI font stack
        "&:hover": {
          textDecoration: "underline",
          backgroundColor: "transparent",
        },
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default LinkButton;
